export default {
  date (isoString) {
    let date = new Date(isoString)
    return [[date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-'), [date.getHours(), date.getMinutes()].join(':')
    ].join(`     `).replace(/(?=\b\d\b)/g, '0')
  },
  day (isoString) {
    if (isoString) {
      let date = new Date(isoString)
      return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    } else {
      return ''
    }
  },
  time (isoString) {
    if (isoString) {
      let date = new Date(isoString)
      return date.getHours() + ':' + date.getMinutes()
    } else {
      return ''
    }
  },
  // 金额小数点
  fixedPrice (val) {
    return Number(val).toFixed(2)
  },
  // 转换数值为.00的格式
  amountFormat (val) {
    // 保留2位小数
    let f = parseFloat(val)
    if (isNaN(f)) {
      return
    }
    f = Math.round(val * 100) / 100
    return f % 1 === 0 ? f + '.00' : f
  },
  statusView (order) {
    let str = ''
    switch (order.status) {
      case '0':
        return '待付款'
      case '1':
        return '待安装'
      case '2':
        return '已完成'
      case '3':
        return '退款售后'
      case 'cancel':
        return '已取消'
    }
    return str
  },
  refundStatusView (order) {
    let str = ''
    switch (order.refundStatus) {
      case '0':
        return '申请退款'
      case '1':
        return '退款审核成功'
      case '2':
        return '退款审核失败'
      case '3':
        return '退款成功'
      case 'cancel':
        return '退款已取消'
    }
    return str
  }
}
